const train_manaer_routes = {
      path: "/organization",
      name: "Organization",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      redirect: 'training_course_manager',
      children: [
        /*{
          path: "agency_info",
          name: 'AgencyInfo',
          component: () => import('@/views/TraingingManager/AgencyInfo/AgencyInfo'),
          meta: { requiresAuth: true },
        },*/

        {
          path: "tea_sd",
          component: () => import('@/views/training_teacher/stu-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "tran_his",
          name: 'orgTrainingHis',
          component: () => import('@/views/TraingingManager/TrainingHis/TrainingHis'),
          meta: {requiresAuth: true},
        },
        // 培训班管理
        {
          path: 'training_course_manager',
          name: 'TrainingCourseManager',
          component: () => import('@/views/TraingingManager/TrainingCourseManager/TrainingCourseManager'),
          meta: {requiresAuth: true},
        },
        // 培训班详情
        {
          path: 'class_detail',
          name: 'TrainingClassDetail',
          component: () => import('@/views/TraingingManager/TrainingClassDetail/TrainingClassDetail'),
          meta: {requiresAuth: true},
        },
        // 创建培训班 十一人制
        {
          path: 'create_class/:status/:level',
          name: 'CreateTrainingClass',
          component: () => import('@/views/TraingingManager/CreateClass/CreateClass'),
          meta: {requiresAuth: true},
        },
        // 创建培训班 五人制
        {
          path: 'create_class_five/:status/:level',
          name: 'CreateTrainingClassFive',
          component: () => import('@/views/TraingingManager/CreateClass/CreateClassFive'),
          meta: {requiresAuth: true},
        },
        // 培训班精彩瞬间
        {
          path: 'class_moment/:classId',
          name: 'ClassMoment',
          component: () => import('@/views/TraingingManager/ClassMoment/ClassMoment'),
          props: true,
          meta: {requiresAuth: true},
        },
        // 修改编辑培训班
        {
          path: 'edit_class/:classId/:status',
          name: 'EditTrainingClass',
          component: () => import('@/views/TraingingManager/EditClass/EditClass'),
          props: true,
          meta: {requiresAuth: true},
        },
        // 修改编辑培训班 - 五人制
        {
          path: 'edit_class_five/:classId/:status',
          name: 'EditTrainingClassFive',
          component: () => import('@/views/TraingingManager/EditClass/EditClassFive'),
          props: true,
          meta: {requiresAuth: true},
        },
        // 某个学员的教案
        {
          path: 'stu_tutorial',
          name: 'StuTutorial',
          component: () => import('@/views/TraingingManager/StusTutorial/StusTutorial'),
          meta: {requiresAuth: true},
        },
        {
          path: "tutorial_detail",
          name: "TutorialDetail",
          component: () => import('@/components/Tutorial/tutorial-detail'),
          meta: {requiresAuth: true},
        },
        // 所有学员的教案
        {
          path: 'all_stus_tutorial',
          name: 'AllStusTutorial',
          component: () => import('@/views/TraingingManager/AllStusTutorial/AllStusTutorial'),
          // props: true,
          meta: {requiresAuth: true},
        },
        // 调整学员名单🎈
        {
          path: 'edit_stus_info/:classId',
          name: 'EditStusInfo',
          component: () => import('@/views/TraingingManager/EditStusInfo/EditStusInfo'),
          props: true,
          meta: {requiresAuth: true},
        },
        // 测评列表页
        {
          path: 'evaluation_list',
          name: 'OrgEvaluationList',
          component: () => import('@/views/TraingingManager/EvaluationList/EvaluationList'),
          meta: {requiresAuth: true},
        },
        // 机构为教师测评
        {
          path: 'create_evaluation/:classId',
          name: 'OrgCreateEvaluation',
          component: () => import('@/views/TraingingManager/Evaluation/CreateEvaluation'),
          props: true,
          meta: {requiresAuth: true},
        },
        // 测评详情页
        {
          path: 'evaluation_detail/:classId',
          name: 'OrgShowEvalua',
          component: () => import('@/views/TraingingManager/Evaluation/ShowEvalua'),
          props: true,
          meta: {requiresAuth: true},
        },
        /* 查看成绩 */
        {
          path: "look_score",
          component: () => import('@/components/score/score-detail'),
          meta: {requiresAuth: true},
        },
        /* 报名列表 */
        {
          path: 'train_registration_manager',
          name: 'TrainRegistrationManager',
          component: () => import('@/views/TraingingManager/TrainRegistrationManager/TrainRegistrationManager'),
          meta: {requiresAuth: true},
        },
        /* 报名中人员列表 */
        {
          path: 'train_personnel_manager',
          name: 'TrainPersonnelManager',
          component: () => import('@/views/TraingingManager/TrainPersonnelManager/TrainPersonnelManager'),
          meta: {requiresAuth: true},
        },
        // 报名详情
        {
          path: "register_info",
          component: () => import('@/components/Registration/RegistrationInfo'),
          meta: {requiresAuth: true},
        },
          // 注册人员列表
        {
          path:'EnrollList',
          component:()=>import('@/views/TraingingManager/EnrollList/EnrollList'),
          meta: {requiresAuth: true},
        },
        // 执照生成列表
        {
          path:'licenseList',
          component:()=>import('@/views/TraingingManager/LicenseList/licenseList'),
          meta: {requiresAuth: true},
        },
        // 文件存档
        {
          path:'documents',
          component: () => import('@/views/Documents/Documents'),
          meta: {requiresAuth: true}
        },
        // 举办地信息模板管理
        {
          path:'address_model',
          name: 'AddressModel',
          component: () => import('@/views/TraingingManager/heighClassPlane/AddressModel'),
          meta: {requiresAuth: true}
        },
        // 投标管理
        {
          path:'heigh_class_list',
          name: 'AddressModel',
          component: () => import('@/views/TraingingManager/heighClassPlane/HeighClassList'),
          meta: {requiresAuth: true}
        },
        // 添加地点模板
        {
          path:'add_model',
          name: 'AddModel',
          component: () => import('@/views/TraingingManager/heighClassPlane/AddModel'),
          meta: {requiresAuth: true}
        },
        // 添加地点模板
        {
          path:'view_model',
          name: 'ViewModel',
          component: () => import('@/views/TraingingManager/heighClassPlane/ViewModel'),
          meta: {requiresAuth: true}
        },
        // 培训班开班计划投标
        {
          path:'sign_plane',
          name: 'SignPlane',
          component: () => import('@/views/TraingingManager/heighClassPlane/SignHeightClassPlane'),
          meta: {requiresAuth: true}
        },
        // 培训班开班计划投标
        {
          path:'sign_plane_complete',
          name: 'SignPlaneComplete',
          component: () => import('@/views/TraingingManager/heighClassPlane/SignPlaneComplete'),
          meta: {requiresAuth: true}
        },
        // 注册管理
        {
          path:'alteration_list',
          name: 'AlterationList',
          component: () => import('@/views/TraingingManager/alteration/AlterationLIst'),
          meta: {requiresAuth: true}
        },
        // 申请人员列表src\views\TraingingManager\alteration\alterationCoachList.vue
        {
          path:'alteration_coach_list_enter',
          name: 'AlterationCoachList',
          component: () => import('@/views/TraingingManager/alteration/alterationCoachListEnter'),
          meta: {requiresAuth: true}
        },
        // 申请人员列表src\views\TraingingManager\alteration\alterationCoachList.vue
        {
          path:'alteration_coach_list_leave',
          name: 'AlterationCoachList',
          component: () => import('@/views/TraingingManager/alteration/alterationCoachListLeave'),
          meta: {requiresAuth: true}
        },
        // 申请详情 src\views\TraingingManager\alteration\AlterationListView.vue
        {
          path:'alteration_view',
          name: 'AlterationView',
          component: () => import('@/views/TraingingManager/alteration/AlterationListView'),
          meta: {requiresAuth: true}
        },
        // 培训班开班申请管理
        {
          path:'class_application',
          name: 'ClassApplication',
          component: () => import('@/views/TraingingManager/TheClassApplication/ClassApplicationManager'),
          meta: {requiresAuth: true}
        },
        // 创建/编辑五人制培训班开班申请
        {
          path:'class_application_five_action',
          name: 'ClassApplicationFiveAction',
          component: () => import('@/views/TraingingManager/TheClassApplication/ClassApplicationAction'),
          meta: {requiresAuth: true}
        },
        // 查看五人制培训班开班申请
        {
          path:'class_application_info',
          name: 'ClassApplicationInfo',
          component: () => import('@/components/ClassApplication/class-application-detail'),
          meta: {requiresAuth: true}
        },
        // 查看某个学员的学习详情
        {
          path: "student_study_learn_view",
          component: () => import("@/views/system_manager/education/studentStudyLearnView"),
          meta: {requiresAuth: true}
        },
        // 计划开班月份列表
        {
          path:'class_plan_list',
          name:'ClassPlanList',
          component:() => import('@/views/TraingingManager/ClassPlan/ClassPlanList'),
          meta:{requiresAuth:true},
        },
        // 添加会员协会开班计划
        {
          path:'add_class_plan_organ',
          name:'AddClassPlanOrgan',
          component:() => import('@/views/TraingingManager/ClassPlan/AddClassPlanOrgan'),
          meta:{requiresAuth:true},
        },
        // 首页
        {
          path:'training_course_list',
          name:'TrainingCourseList',
          component:() => import('@/views/TraingingManager/TrainingCourseManager/TrainingCourseList'),
          meta:{requiresAuth:true},
        },
        // 处罚人员名单
        {
          path:'punish_people',
          name:'punishPeople',
          component:() => import('@/views/TraingingManager/PunishPeople/punishPeople'),
          meta:{requiresAuth:true},
        },
        /* 处罚申请详情 */
        {
          path:"punishApply",
          component :() => import('@/views/punishPeople/punishApplyInfo'),
          meta: {requiresAuth: true},
        },
        /* 处罚详情 */
        {
          path:"punishResultInfo",
          component :() => import('@/views/punishPeople/punishResultInfo'),
          meta: {requiresAuth: true},
        },
        {
          path: "teacherList",
          component: () => import("@/views/system_manager/teacher/tea-teacher"),
          meta: {requiresAuth: true}
        },
        /* 讲师培训历程 */
        {
          path: "td",
          component: () => import("@/views/system_manager/teacher/tea-train"),
          meta: {requiresAuth: true}
        },
      ]
    }

export default train_manaer_routes;
